import React from "react";
import { Grid, Typography } from "@mui/material";
import SearchField from "../search/SearchField.tsx";
import ExampleItems from "../example/ExampleItems.tsx";
import { Trans } from "@lingui/react/macro";

interface CircleComponentProps {
  children?: React.ReactNode;
}

const CircleContent: React.FC<CircleComponentProps> = () => {
  return (
    <React.Fragment>
      <Grid size={{ xs: 6, lg: 10 }} sx={{ m: "35% 0% 0% 0%" }}>
        <Typography
          variant="h1"
          color="primary"
          sx={{
            fontSize: { lg: "4rem", md: "3.3rem", sm: "3rem", xs: "1.5rem" },
            fontWeight: "bold",
          }}
        >
          <Trans
            context={
              "Greeting message stating the name of the service is Tally."
            }
          >
            Hi, I'm Tally.
          </Trans>
        </Typography>
        <Typography
          variant="h1"
          color="primary"
          sx={{
            fontSize: { lg: "4rem", md: "3.3rem", sm: "3rem", xs: "1.5rem" },
            fontWeight: "bold",
          }}
        >
          <Trans
            context={
              "Banner at the initial screen trying to engage the user with asking questions."
            }
          >
            How can I help?
          </Trans>
        </Typography>
      </Grid>
      <Grid
        size={{ xs: 12, lg: 10 }}
        sx={{
          m: { xs: "2% 0% 2% 0%" },
          width: { xs: "80%", lg: "120%" },
        }}
      >
        <SearchField />
      </Grid>
      <Grid
        size={{ xs: 6, sm: 8 }}
        sx={{
          m: { xs: "2% 0% 30% 0%" },
        }}
      >
        <ExampleItems />
      </Grid>
    </React.Fragment>
  );
};

export default CircleContent;
